import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from '@mui/material/Paper';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDetailPagin } from 'src/common/helper';
import { getAPI, postAPI, postFormDataAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import ConfirmDelete from '../../common/modal/ConfirmDelete';
import Pagin, { PaginationType } from '../../common/Pagin';
import BtnGradient from '../../common/button/BtnGradient';
import BtnOutlineGradient from '../../common/button/BtnOutlineGradient';
import InputDatePickerRange from 'src/components/common/field/InputDatePickerRange';
import DialogDetail from './dialog/DialogDetail';
import { useNotify } from 'src/context/ContextNotify';

const inputStyle = {
  flex: 1,
  height: '32px',
  backgroundColor: 'primary.light',
  '&.MuiAutocomplete-root .MuiOutlinedInput-root': {
    py: '7px',
  },
  '&.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input':
    {
      py: 0,
      fontSize: '14px',
    },
}

type FilterType = {
  name: string;
  person: string;
  patientid: string;
  dates: string;
  status: string;
  startDate: string | null;
  endDate: string | null;
};

const TaskList = () => {
  const notifyContext = useNotify();
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);
  const [checkAPI, setCheckAPI] = useState(false);
  const [pagination, setPagination] = useState<PaginationType>();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteTaskId, setDeleteTaskId] = useState('0');

  const [open, setOpen] = useState(false);
  const [patients, setPatients] = useState([]);
  const loading = open && patients.length === 0;
  const [openDialogDetail, setOpenDialogDetail] = useState<boolean>(false);
  const [rowSelect, setRowSelect] = useState('');

  const handleOpenDialogDetail = (row: any) => {
    setRowSelect(row);
    setOpenDialogDetail(true);
  };

  const handleCloseDialogDetail = () => {
    setOpenDialogDetail(false);
  };

  const [searchs, setSearchs] = useState<FilterType>({
    name: '',
    person: '',
    patientid: '',
    dates: '',
    status: '',
    startDate: '',
    endDate: '',
  });

  const getTaskList = (page: number) => {
    setCheckAPI(false);
    const token = getToken();
    postAPI(`/patient/task-search?token=${token}`, {
      page: page,
      ...searchs,
      dates: `${
        searchs.startDate && searchs.endDate
          ? `${searchs.startDate} ~ ${searchs.endDate}`
          : ''
      }`,
    })
      .then((res) => {
        if (res.code === 200) {
          setTasks(res.data.items);
          setPagination(res.data.pagination);
          setStatuses(res.data.statuses);
          setUsers(res.data.users);
        }
      })
      .finally(() => {
        setCheckAPI(true);
      });
  };

  useEffect(() => {
    getTaskList(1);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!open) {
      setPatients([]);
    }
  }, [open]);

  const handleSearch = () => {
    getTaskList(1);
  };
  const handleCreateNew = () => {
    navigate('/patient/task-edit');
  };
  const handleEditClick = (id: string) => {
    navigate(`/patient/task-edit?id=${id}`);
  };
  const handleChangeFilter = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setSearchs({
      ...searchs,
      [name]: value,
    });
  };

  const handleInputSearch = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setSearchs({
      ...searchs,
      [name]: value,
    });
  };

  const handlePageChange = (eventL: any, value: number) => {
    getTaskList(value);
  };

  const handleStatusChange = (event: any, value: any) => {
    const status = value.map((val: any) => val.value);
    setSearchs({
      ...searchs,
      status: status,
    });
  };

  const handleChangeDateRange = (
    startDate: string | null,
    endDate: string | null
  ) => {
    setSearchs({
      ...searchs,
      startDate: startDate,
      endDate: endDate,
    });
  };

  const onPatientChange = (e: any, value: any) => {
    setSearchs({
      ...searchs,
      patientid: value?.id || '',
    });
  };

  const onInputPatientChange = (e: any, value: any) => {
    const token = getToken();
    getAPI(`/master/suggest?type=patient&keyword=${value}&token=${token}`)
      .then((res) => {
        if (res.code === 200) {
          setPatients(res.data.result);
        }
      })
      .finally(() => {
        setCheckAPI(true);
      });
  };

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };
  const handleDeleteClick = (id: string) => {
    setOpenConfirm(true);
    setDeleteTaskId(id);
  };

  const handleDelete = () => {
    setOpenConfirm(false);
    const token = getToken();
    const formData = new FormData();
    formData.append('id', deleteTaskId);

    try {
      postFormDataAPI(`/patient/task-delete?token=${token}`, formData).then(
        (res) => {
          if (res.code === 200) {
            notifyContext.setNotifyMessage({
              show: true,
              message: '削除しました。',
              type: 'success',
            });
            getTaskList(1);
          }
          if (res.code === 500 || res.code === 501) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error'
            });
          }
        }
      );
    } catch (error) {
      console.error('Failed to delete data:', error);
      return;
    }
  };

  const handleDataStatusChange = (event: any, taskid: any) => {
    const token = getToken();
    const formData = new FormData();
    formData.append('id', taskid);
    formData.append('status', event.target.value);

    try {
      postFormDataAPI(`/patient/task-set-status?token=${token}`, formData).then(
        (res) => {
          if (res.code === 200) {
            getTaskList(1);
          }
        }
      );
    } catch (error) {
      console.error('Failed to update data:', error);
      return;
    }
  };

  return (
    <>
      <Stack width={'100%'}>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          spacing={'8px'}
          mb={'30px'}
        >
          <OutlinedInput
            placeholder={'タスク名'}
            sx={{
              fontSize: '14px',
              height: '32px',
              my: '8px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
              '& .MuiInputBase-input': { padding: '5px 14px' },
              '& input::placeholder': {
                fontSize: '14px',
                fontWeight: 500,
                color: '#CCD1D9',
                opacity: 1,
              },
              backgroundColor: 'primary.light',
              flex: 1,
            }}
            inputProps={{
              sx: {
                backgroundColor: 'primary.light',
              },
            }}
            name='name'
            value={searchs.name}
            onChange={(event) => handleInputSearch(event)}
          />
          <Select
            value={searchs.person}
            name='person'
            displayEmpty
            onChange={(e) => handleChangeFilter(e)}
            sx={{
              height: '32px',
              '& .MuiSelect-select.MuiSelect-outlined': {
                py: '5px',
                color: searchs.person === '' ? '#CCD1D9' : '',
                backgroundColor: 'primary.light',
                fontSize: '14px',
              },
              flex: 1,
            }}
          >
            <MenuItem value='' className='placeholder'>
              担当者
            </MenuItem>
            {users.map((status: any, index) => {
              return (
                <MenuItem key={index} value={status.userid}>
                  {status.name}
                </MenuItem>
              );
            })}
          </Select>
          <Autocomplete
            id='asynchronous-demo'
            sx={inputStyle}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            isOptionEqualToValue={(patient: any, value) =>
              patient.fullname === value.fullname
            }
            getOptionLabel={(patient) => patient.fullname}
            options={patients}
            loading={loading}
            onChange={onPatientChange}
            onInputChange={onInputPatientChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label=''
                placeholder='患者'
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color='inherit' size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          <InputDatePickerRange
            startDate={searchs.startDate}
            endDate={searchs.endDate}
            placeholder='期間'
            sxInput={{ height: '32px', width: '240px', fontSize: '14px' }}
            onChange={handleChangeDateRange}
          />
          <Autocomplete
            multiple
            id='tags-outlined'
            options={statuses}
            getOptionLabel={(option: any) => option.label}
            // defaultValue={[statuses[2]]}
            isOptionEqualToValue={(stat: any, value) =>
              stat.value === value.value
            }
            filterSelectedOptions
            onChange={handleStatusChange}
            renderInput={(params) => (
              <TextField {...params} label='' placeholder='ステータス' />
            )}
            sx={inputStyle}
          />
          <BtnGradient text='検索' handleButtonClick={handleSearch} />
          <BtnOutlineGradient
            text='新規作成'
            handleButtonClick={handleCreateNew}
            width='120px'
            srcStartIcon='/images/icons/ic-plus-gradient.svg'
          />
        </Stack>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: 'none',
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              '& .MuiTableCell-root.MuiTableCell-head': {
                borderBottom: '1px solid #F3F3F3',
                fontWeight: 700,
                p: '6px 16px',
                fontSize: '14px',
              },
              '& .MuiTableCell-root.MuiTableCell-body': {
                color: 'primary.dark',
                fontSize: '14px',
                py: '6px',
              },
            }}
            aria-label='simple table'
          >
            <TableHead>
              <TableRow>
                <TableCell>タスク名</TableCell>
                <TableCell>担当者</TableCell>
                <TableCell>患者ID</TableCell>
                <TableCell>患者名</TableCell>
                <TableCell>ステータス</TableCell>
                <TableCell>期限</TableCell>
                <TableCell width={'100px'}></TableCell>
                <TableCell width={'100px'}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {checkAPI ? (
                <>
                  {tasks.map((row: any, index) => (
                    <TableRow
                      hover
                      key={index}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        '& .MuiTableCell-root.MuiTableCell-body': {
                          py: '4px',
                          borderBottom: '1px solid #F3F3F3',
                        },
                        cursor: 'pointer',
                      }}
                    >
                      <TableCell onClick={() => handleOpenDialogDetail(row)}>
                        {row.task}
                      </TableCell>
                      <TableCell onClick={() => handleOpenDialogDetail(row)}>
                        {row.persons}
                      </TableCell>
                      <TableCell onClick={() => handleOpenDialogDetail(row)}>
                        {row.patientid}
                      </TableCell>
                      <TableCell onClick={() => handleOpenDialogDetail(row)}>
                        {row.patient}
                      </TableCell>
                      <TableCell>
                        <Select
                          className='select-status'
                          value={row.status}
                          onChange={(event) =>
                            handleDataStatusChange(event, row.id)
                          }
                          sx={{
                            '& .MuiSelect-select.MuiSelect-outlined': {
                              py: '5px',
                            },
                          }}
                        >
                          {statuses.map((status: any, index) => {
                            return (
                              <MenuItem key={index} value={status.value}>
                                {status.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </TableCell>
                      <TableCell onClick={() => handleOpenDialogDetail(row)}>
                        {row.deadline}
                      </TableCell>
                      <TableCell>
                        <BtnOutlineGradient
                          text='変更'
                          handleButtonClick={() => handleEditClick(row.id)}
                        />
                      </TableCell>
                      <TableCell>
                        <BtnOutlineGradient
                          text='削除'
                          handleButtonClick={() => handleDeleteClick(row.id)}
                          grandient='#DA4453'
                          color='#DA4453'
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  {tasks.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={11}
                        sx={{ textAlign: 'center', verticalAlign: 'center' }}
                      >
                        データがありません
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ) : (
                <>
                  {Array.from(Array(10)).map((_, index) => {
                    return (
                      <TableRow key={index}>
                        {Array.from(Array(8)).map((_, index) => {
                          return (
                            <TableCell key={index}>
                              <Skeleton
                                variant='rounded'
                                width={'100%'}
                                height={30}
                              />
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {tasks.length > 0 && pagination && (
          <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
            <Typography
              component='label'
              sx={{
                color: '#AAB2BD',
                fontWeight: '400',
                fontSize: '10px',
                lineHeight: '12px',
              }}
            >
              {getDetailPagin(pagination)}
            </Typography>
          </Box>
        )}
        {tasks.length > 0 && pagination && pagination.page && (
          <Pagin handlePageChange={handlePageChange} pagination={pagination} />
        )}
      </Stack>
      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />

      <DialogDetail
        open={openDialogDetail}
        onClose={handleCloseDialogDetail}
        rowSelect={rowSelect}
        handleEditClick={handleEditClick}
        handleDeleteClick={handleDeleteClick}
      />
    </>
  );
};

export default TaskList;
